<template>
  <div :class="modalClass" @click="toggleModal(name, title), closeMenu()">
    <div class="content" @modal-close="toggleModal(name)" @click.stop>
      <span class="close" @click="toggleModal(name, title), closeMenu()"
        >X</span
      >
      <slot @modal-close="toggleModal(name)"></slot>
    </div>
  </div>
</template>

<script lang="ts" setup>
import useModal from "@/hooks/useModal";
import { onUnmounted, inject } from "vue";
import { useMenuStore } from "@/stores/root/menu";

const menuStore = useMenuStore();
const props = defineProps({
  name: {
    type: String,
    default: "",
  },
  title: {
    type: String,
    default: "",
  },
});
function closeMenu() {
  menuStore.setInactive();
}
const { toggleModal, onModalMounted, onModalDestroy } = useModal();
const modalClass = onModalMounted(props.name, props.title);
onUnmounted(() => {
  onModalDestroy(props.name);
});
</script>
